
<template>
  <div class="check_box">
    <div class="noEmpty">
      <div class="empty_btn"></div>
      <p class="title">提现申请已受理</p>
      <!-- <p class="info">稍后请关注银行卡余额变动</p> -->
      <!--<p class="info">稍后请关注微信钱包余额变动</p>-->
      <div v-if="payType == '0'">
        <p class="info">稍后请关注支付宝余额变动</p>
      </div>
      <div v-if="payType == '1'">
        <p class="info">稍后请关注微信钱包余额变动</p>
      </div>
    </div>
    <div class="btn_box">
      <span class="btn"
            @click="toPage">确定</span>
    </div>

  </div>
</template>

<script>

export default {
  components: {
    // Head,
  },
  data () {
    return {
      isBindCard: '1',
      money: '',
      payType:''
    }
  },
  mounted () {
    this.money = this.$route.query.money;//账户余额
    this.util.title('申请提现');
    this.payType=this.$route.query.payType;
  },
  methods: {
    toPage () {
      this.$router.push({
        path: '/vipActive/myCard',
        query: {
          isActive: 2,
        }
      });
    },
  }

}
</script>
<style scoped>
.check_box {
  background: #ffff;
  padding-top: 0.65rem;
}
.btn_box {
  text-align: center;
}
.btn {
  display: inline-block;
  color: #ffffff;
  font-size: 0.17rem;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 0.3rem;
  /* opacity: 0.5; */
}
.noEmpty {
  text-align: center;
}
.empty_btn {
  width: 1.19rem;
  height: 0.95rem;
  background: url('../../assets/img/vip/withDral.png') no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
}
.title {
  color: #333;
  font-size: 0.16rem;
  margin-top: 0.19rem;
}
.info {
  font-size: 0.14rem;
  color: #999;
  margin-top: 0.15rem;
  margin-bottom: 0.68rem;
}
</style>
